module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_bg_h5.9353570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_bg_h5.png
// module id = WSnH
// module chunks = 34